import {
	FieldErrors,
	FieldValues,
	UseFormRegister,
	UseFormSetValue,
	UseFormWatch,
} from 'react-hook-form';
import { Input, InputList, InputText } from '@/components/form';
import React from 'react';
import { countriesService, GET_STATES } from '@/api';
import { useQuery } from '@tanstack/react-query';
import { Option } from '@/interfaces';

interface Props {
	errors: FieldErrors<FieldValues>;
	watch: UseFormWatch<FieldValues>;
	register: UseFormRegister<FieldValues>;
	setValue: UseFormSetValue<FieldValues>;
}

export const PersonalAccountForm: React.FC<Props> = ({
	errors,
	watch,
	register,
	setValue,
}) => {
	const rules = {
		accountName: {
			required: { value: true, message: 'This is required.' },
			pattern: {
				value: /^[A-Za-z]+$/i,
				message: 'Only alphabetic characters accepted',
			},
			maxLength: {
				value: 65,
				message: 'Your first name has to have less than 65 characters',
			},
		},
		routingNumber: {
			required: { value: true, message: 'This is required.' },
			pattern: {
				value: /^[0-9]+$/,
				message: 'Only numbers accepted',
			},
			maxLength: {
				value: 9,
				message: 'Your routing number has to have less than 9 characters',
			},
		},
		accountNumber: {
			required: { value: true, message: 'This is required.' },
			pattern: {
				value: /^[0-9]+$/,
				message: 'Only numbers accepted',
			},
			maxLength: {
				value: 34,
				message: 'Your account number has to have less than 34 characters',
			},
		},
		repeatAccountNumber: {
			required: { value: true, message: 'This is required.' },
			validate: (value: string) => {
				value === watch('accountNumber') ||
					'The checking account number does not match';
			},
		},
		idNumber: {
			required: { value: true, message: 'This is required.' },
		},
	};
	// const [state, setState] = React.useState<string>('');
	const [allStates, setAllStates] = React.useState<Option[]>();
	const { data: statesData } = useQuery({
		queryKey: [GET_STATES],
		queryFn: () => countriesService.getStates('1'),
	});

	React.useEffect(() => {
		if (statesData) {
			const auxStates: Option[] = [
				{
					name: '',
					label: 'Select your State',
					placeholder: true,
				},
			];
			statesData.data.states.map((state) =>
				auxStates.push({
					label: state.name,
					name: `${state.id}`,
				})
			);
			setAllStates(auxStates);
		}
	}, [statesData]);

	return (
		<>
			<InputText
				title="Name on Account"
				name="accountName"
				placeholder="Ex: Norma Lauren"
				register={register}
				rules={rules.accountName}
				error={errors.accountName}
			/>
			<Input
				title="Bank Routing Number"
				name="routingNumber"
				placeholder="Ex: 99999999999"
				register={register}
				rules={rules.routingNumber}
				error={errors.routingNumber}
			/>
			<Input
				title="Checking Account Number"
				name="accountNumber"
				placeholder="Ex: 17171717171717171"
				register={register}
				rules={rules.accountNumber}
				error={errors.accountNumber}
			/>
			<Input
				title="Re enter Checking Account Number"
				name="repeatAccountNumber"
				placeholder="Ex: 17171717171717171"
				register={register}
				rules={rules.repeatAccountNumber}
				error={errors.repeatAccountNumber}
			/>
			<Input
				title="Driver's License Number or other State/issued id"
				name="idNumber"
				placeholder="Ex: D123-456-7890"
				register={register}
				rules={rules.idNumber}
				error={errors.idNumber}
			/>
			{allStates && (
				<InputList
					register={register}
					name="state"
					title="State"
					options={allStates}
					setValueInput={setValue}
					// handleChange={(value) => {
					// 	setState(value);
					// }}
				/>
			)}
		</>
	);
};
